module.exports = __webpack_public_path__ + "fonts/PrestigeEliteStd-Slanted.a69ca554.woff";